import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import Icon from '../../../../icons/Icon';

class WatchlistLevelModalComponent extends Component<Props> {
  public render() {
    const { visible, onClose } = this.props;
    return (
      <Dialog
        header={this.getHeader}
        className={'custom-dialog w-2/5 h-auto'}
        visible={visible}
        onHide={onClose}
        closable={false}
        closeOnEscape={true}
        dismissableMask={true}
      >
        {this.getContent()}
      </Dialog>
    );
  }

  private getHeader = () => {
    return (
      <div className={'bg-[#F9FAFB] h-[54px] rounded-t-[6px] flex items-center justify-between align-center pl-4 border-b'}>
        <div className={'flex items-center justify-start align-center w-full lg:w-auto gap-x-3'}>
          <Icon icon={'search'} className={'text-[#4F4F4F] fill-f-black-2'} size={20} />
          <div className={'!text-f-black-2 font-normal text-md'}>Level</div>
        </div>
      </div>
    );
  };

  private getContent = () => {
    const { level, type } = this.props;
    if (level == undefined || type == undefined) return;
    if (type == 'Individual') {
      switch (level) {
        case 1:
          return (
            <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
              <span className={'w-full'}>Identification</span>
            </div>
          );
        case 2:
          return (
            <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
              <span className={'w-full'}>Name</span>
            </div>
          );
        case 3:
          return (
            <div className={'h-full w-full p-0 m-0'}>
              <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
                <span className={'w-full'}>Name</span>
              </div>
              <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
                <span className={'w-full'}>Date of Birth</span>
              </div>
            </div>
          );
        case 4:
          return (
            <div className={'h-full w-full p-0 m-0'}>
              <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
                <span className={'w-full'}>Name</span>
              </div>
              <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
                <span className={'w-full'}>Citizenship</span>
              </div>
            </div>
          );
        case 5:
          return (
            <div className={'h-full w-full p-0 m-0'}>
              <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
                <span className={'w-full'}>Name</span>
              </div>
              <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
                <span className={'w-full'}>Date of Birth</span>
              </div>
              <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
                <span className={'w-full'}>Citizenship</span>
              </div>
            </div>
          );
      }
    } else if (type == 'Entity') {
      switch (level) {
        case 1:
          return (
            <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
              <span className={'w-full'}>Identifier</span>
            </div>
          );
        case 2:
          return (
            <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
              <span className={'w-full'}>Name</span>
            </div>
          );
        case 3:
          return (
            <div className={'h-full w-full p-0 m-0'}>
              <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
                <span className={'w-full'}>Name</span>
              </div>
              <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'}>
                <span className={'w-full'}>Date of Registration</span>
              </div>
            </div>
          );
      }
    }
  };
}

interface Props {
  visible: boolean;
  level: number | undefined;
  type: string | undefined | null;
  onClose: () => void;
}

export default WatchlistLevelModalComponent;
